import axios, { AxiosInstance } from 'axios'

import { getCommonItem } from '@/utils/localStorage'

import { tokenHeader, tokenKey } from '@/auth/types'

import { baseAPIUrl, baseEventsAPIUrl } from './urls'

const apiConfig = {
  backend: { baseURL: baseAPIUrl, headers: { 'Content-Type': 'application/json' } },
  eventsService: { baseURL: baseEventsAPIUrl, headers: { 'Content-Type': 'application/json' } },
}

export class BaseApiService {
  protected client: AxiosInstance

  constructor(service: keyof typeof apiConfig) {
    const { baseURL, headers } = apiConfig[service]
    this.client = axios.create({ baseURL, headers })

    this.client.interceptors.request.use(function (config) {
      const token = getCommonItem(tokenKey, window.config.EXPERIMENT_NAME)

      if (token) {
        config.headers[tokenHeader] = token
      }
      return config
    })
  }
}
